import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Cart Drawer
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  // Open the drawer on ANY add-to-cart event
  #handleCartAdd = () => {
    this.showDialog();
  };

  open() {
    this.showDialog();

    // Close if installments CTA is clicked (prevents dialog overlap)
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const sr = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = sr?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// ---- small global helper so other scripts can open the drawer if needed
window.CartDrawer = window.CartDrawer || {};
window.CartDrawer.open = () => {
  const el = document.querySelector('cart-drawer-component');
  if (el?.open) el.open(); else window.location.href = '/cart';
};
